module.exports = __webpack_public_path__ + "img/minerule.6f08a054.jpg";